export const MEDIA_QUERY_HEADER = 'headerMobile';
export const PADDING_TOP_LOGO = '8px';
